// Calendar View Type Enum
// NOTE: numeric values differ from ReportPeriodTypeEnum — do not interchange.
// Day = 2 added per Point 13 (attendance now supports a single-day view).
export const CalendarViewTypeEnum = Object.freeze({
  Week: 0,
  Month: 1,
  Day: 2,
});
